<template>
  <table class="table table-hover table-striped">
    <thead>
      <tr>
        <th>Datum</th>
        <th>Orderreferens</th>
        <th>Kostnad</th>
      </tr>
    </thead>

    <tbody v-if="earnings.length > 0">
      <tr v-for="earning in earnings">
        <td class="align-middle">
          <small>
            {{ dayMonthYear(earning.created_at) }}
          </small>
        </td>
        <td class="align-middle">
          <small>
            {{ earning.order_data.reference }}
          </small>
        </td>
        <td class="align-middle">
          <small>
            {{ earning.cost }} kr
            <small class="text-muted">
              (ex. moms)
            </small>
          </small>
        </td>
      </tr>
    </tbody>

    <tbody v-else>
    <tr>
      <td colspan="3" class="text-center text-muted">
        Du har inget att fakturera för nuvarande fakturaperiod
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>

  import DateMixin from "../../../../app/mixins/helpers/DateMixin"

  export default {
    name: "OrderEarnings",
    mixins: [
      DateMixin
    ],
    props: {
      earnings: {
        required: true,
        format: Array
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Earnings/Partials/Order.vue